import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const FormContainer = styled.section`
    width: 100%;
    margin: 5% 0;
    header{
        h1{
            text-align: center;
        }
    }

    form{
        width: 45%;
        margin: 0 auto;
        margin-top: 2%;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;

        input, textarea{
            border: 1px solid ${Colors.grey};
            border-radius: 15px;

            font-size: .85rem;
            color: ${Colors.grey};

            width: 100%;
            margin-top: 1rem;
            padding: .5rem .75rem;

            &:nth-of-type(2),
            &:nth-of-type(3){
                width: calc(50% - 1%);
            }
            &:nth-of-type(2){
                margin-right: 1%;
            }
            &:nth-of-type(3){
                margin-left: 1%;
            }

            &:focus-visible,
            &:focus{
                outline: none;
                border: 1px solid ${Colors.orange};
                color: ${Colors.orange};

                &::placeholder{
                    color: ${Colors.orange};
                }
            }
        }

        footer{
            display: flex;
            align-items: center;
            margin-top: 15px;

            a{

                display: flex;
                align-items: center;

                margin: 0 15px;
                font: 1rem/1 'Varela Round',arial,sans-serif;
                color: #F36A10;
                overflow: hidden;

                svg{
                    width: 15px;
                    margin-left: 10px;
                    fill: ${Colors.orange};
                }
            }
        }
    }
`;